import React, { useRef, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import {
  faAngleRight,
  faPlug,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Basic_Info_Offcan.css";
import Blue_Btn from "../../../../common/common_btn/blue_btn/Blue_Btn";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { useForm } from "react-hook-form";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";

const Basic_Info_Offcan = ({ show, handleClose }) => {
  const fileInputRef = useRef(null);
  const [profileImg, setProfileImg] = useState(
    "/assets/images/header/profile/user1.png"
  );

  const handlePlusClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Only images
    if (!file.type.startsWith("image/")) return;

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setProfileImg(previewUrl);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  return (
    <Offcanvas
      className="Basic_Info_Offcan common_offcanvas Profile_Offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn backText="Basic Information" />
          </div>
        </Offcanvas.Title>

        <div className="profile_top_div">
          <div className="pro_pic_div">
            <img src={profileImg} className="pro_img" alt="profile" />
          </div>
          <div className="plus_icon_div" onClick={handlePlusClick}>
            <FontAwesomeIcon icon={faPlus} className="plus_icon" />
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="body_div">
          <Form className="add_form all_tabs_holder">
            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>User ID</Form.Label>
              <Form.Control type="text" placeholder="Enter User ID" />

              {errors?.credit_price && (
                <Form.Text className="text-danger">
                  {errors?.credit_price?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>Designation / Role</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Designation / Role"
              />

              {errors?.credit_price && (
                <Form.Text className="text-danger">
                  {errors?.credit_price?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>Full Name</Form.Label>
              <Form.Control type="text" placeholder="Enter Full Name" />

              {errors?.credit_price && (
                <Form.Text className="text-danger">
                  {errors?.credit_price?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>Contact No.</Form.Label>
              <Form.Control type="text" placeholder="Enter Contact No." />

              {errors?.credit_price && (
                <Form.Text className="text-danger">
                  {errors?.credit_price?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>Email</Form.Label>
              <Form.Control type="text" placeholder="Enter Email" />

              {errors?.credit_price && (
                <Form.Text className="text-danger">
                  {errors?.credit_price?.message}
                </Form.Text>
              )}
            </Form.Group>
          </Form>

          <div className="offcanvas_footer">
            <p className="bold_text">Edit Profile: </p>
            <p className="simple_text">
              Would you like to make changes to your details?
            </p>

            <div className="btn_div">
              <Gray_Btn btnText={"Edit"} />
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Basic_Info_Offcan;
